export enum MediaTypes {
  VIDEO,
  IMAGE,
  AUDIO,
}
